import React from 'react';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import update from 'react-addons-update';
import SMORoomEditAttachmentView from './SMORoomEditAttachmentView';

class SMORoomEditMediaFragmentAttachmentsView extends React.Component {
  
  componentDidMount() {
    const self = this;
    let originalPosition,
        $sortable = $(this.refs.sortable);
    $sortable.sortable({
      start: function(e, ui) {
        originalPosition = ui.item.index();
      },
      update: function(e, ui) {
        var items = update(self.props.items, {$splice: [ 
          [originalPosition, 1], 
          [ui.item.index(), 0, self.props.items[originalPosition]] 
        ]});
        items.forEach(function(item, index) {
          item.sort_order = index;
        });
    
        if (self.props.delegate && typeof self.props.delegate.sortOrderDidChange === 'function'){
          self.props.delegate.sortOrderDidChange(e, {name: 'attachments', items: items});
        }
      }
    });
  }
  
  handleAddItem(e) {
    e.preventDefault();
    this.refs.inputFile.click();
  }
  
  handleDeleteItem(item, index, e) {
    if (this.props.items.length == 1) {
      window.alert(I18n.t("dashboard.notice_000005"));
    } else if (window.confirm(I18n.t("dashboard.notice_000003"))) {
      $(document).trigger("SMRoomHandleDestroyHasManyAssociationItems", [{name: 'attachments', id: item.id}]);
    }
  }
  
  showLargeImage(e) {
    e.preventDefault();
    const el = e.currentTarget;
    if(this.props.delegate && typeof this.props.delegate.thumnailImageDidSelect === 'function'){
      this.props.delegate.thumnailImageDidSelect(
        SMFormatHelper.imageURLWithTransform(el.href, {width: 630, height: 420, crop: 'pad', background: '#9c9c9c'}),
        el.title
      );
    }
  }
  
  itemDidAdd(e) {
    if(this.props.delegate && typeof this.props.delegate.fileFieldDidChangeValue === 'function'){
      this.props.delegate.fileFieldDidChangeValue(e);
    }
    e.currentTarget.value = null;
  }
  
  render() {
    const createItem = function(item, index) {
      return <SMORoomEditAttachmentView key={item.id+'-'+index} delegate={this} item={item} index={index} errors={this.props.errors} />;
    };
    
    return(
      <div>
        <div ref="sortable">
          {this.props.items.map(createItem, this)}
        </div>
        <input type='file' ref='inputFile' name='attachments[]' onChange={this.itemDidAdd.bind(this)} hidden multiple />
        <div className="form-box">
          <a className="button button-gray form-img-button"
            onClick={this.handleAddItem.bind(this)}><i className="fa fa-plus"></i> 写真を追加</a>
          <SMFormValidationMessage name='attachments' errorText={SMFormatHelper.errorText('Room', 'thumbnail_ids', this.props.errors)} />
        </div>
      </div>
    );
  }
}

export default SMORoomEditMediaFragmentAttachmentsView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditMediaFragmentAttachmentsView.jsx